import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "patient_profile_rates_statistic" } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-space-between text-subtitle-1 mb-4" },
        [
          _c("span", { staticClass: "mr-4" }, [
            _vm._v(
              "\n      " + _vm._s(_setup.t("Отзывы", _setup.options)) + "\n    "
            ),
          ]),
          _vm._v("\n    " + _vm._s(_setup.countAll) + "\n  "),
        ]
      ),
      _vm._v(" "),
      _setup.countAccurate
        ? _c(VProgressLinear, {
            staticClass: "mb-4",
            attrs: {
              height: "8",
              rounded: "",
              value: _setup.valueProgressReviews,
              color: "success",
              "background-color": "error",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.countPositive
        ? _c("div", { staticClass: "d-flex justify-space-between mb-2" }, [
            _c(
              "span",
              { staticClass: "text-body-1 text-secondary--text mr-4" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.t("Положительные", _setup.options)) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "amount-icon text-body-2 rounded bg-success success--text",
              },
              [_vm._v("\n      " + _vm._s(_vm.countPositive) + "\n    ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.countNegative
        ? _c("div", { staticClass: "d-flex justify-space-between mb-2" }, [
            _c(
              "span",
              { staticClass: "text-body-1 text-secondary--text mr-4" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.t("Отрицательные", _setup.options)) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "amount-icon text-body-2 rounded bg-error error--text",
              },
              [_vm._v("\n      " + _vm._s(_vm.countNegative) + "\n    ")]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }